import { getAmplitudeInstance } from '@alltrails/shared/utils/amplitudeHelpers';
import { GEAR_GLOBAL_HEADER_CLICKED, GIVE_PRO_GLOBAL_HEADER_CLICKED } from 'utils/constants/AmplitudeEvent';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { US } from 'constants/CountryCode';

const { ALLTRAILS_GEAR, GIVE_PRO, SHOP } = StringConstantsMixin.strings;

const GIVE_PRO_LINK = {
  label: GIVE_PRO,
  linkPath: '/gift?ref=header', // automatically replaced in SideDrawer with mobile-header
  onClick: () => getAmplitudeInstance().logEvent(GIVE_PRO_GLOBAL_HEADER_CLICKED)
};

export function getShopLink(ipCountryCode) {
  if (ipCountryCode === US) {
    return {
      label: SHOP,
      dropdown: [
        {
          label: ALLTRAILS_GEAR,
          linkPath: 'https://shop.alltrails.com/',
          onClick: () => getAmplitudeInstance().logEvent(GEAR_GLOBAL_HEADER_CLICKED),
          openInNewWindow: true
        },
        GIVE_PRO_LINK
      ]
    };
  }

  return GIVE_PRO_LINK;
}
